import { GrowthBook } from "@growthbook/growthbook"
import { TOKEN_GROWTHBOOK, SENTRY_ENV } from "../config"

/**
 * GrowthBook singleton instance (SDK core, sin wrapper de React).
 * Compatible con Webpack 3 + Babel 6.
 *
 * Uso:
 *   import { gb, useFeatureIsOn } from '../utils/growthbook'
 *   const showFeature = useFeatureIsOn("my-feature")
 */
export const gb = new GrowthBook({
  apiHost: "https://growth-proxy.talisis.com",
  clientKey: TOKEN_GROWTHBOOK,
  enableDevMode: SENTRY_ENV !== "production",
  trackingCallback: function(experiment, result) {
    if (window.gtag) {
      window.gtag("event", "experiment_viewed", {
        experiment_id: experiment.key,
        variation_id: result.key,
      })
    }
  },
})

// Cargar features desde el proxy (con auto-refresh para cambios en tiempo real)
// featuresReady se resuelve cuando los features están disponibles por primera vez
export var featuresReady = gb.loadFeatures({ autoRefresh: true })

/**
 * Setea los atributos del usuario para targeting.
 * Llamar después del login o cuando cambie el user.
 * Devuelve la promesa de setAttributes para encadenar.
 */
export var setGrowthBookUser = function(user) {
  if (!user) return Promise.resolve()
  return gb.setAttributes({
    id: String(user.id),
    email: user.email,
    role: user.role,
    centerId: user.center_id,
    userType: user.user_type,
    platforms: user.platform_permissions || [],
    isImpersonating: user.is_impersonating || false,
  })
}

/**
 * Hook custom para evaluar si un feature está ON.
 * Usa subscribe() para permitir múltiples listeners simultáneos.
 * Funciona con React 16.8+ hooks.
 */
export var useFeatureIsOn = function(featureKey) {
  var React = require("react")
  var ref = React.useState(gb.isOn(featureKey))
  var isOn = ref[0]
  var setIsOn = ref[1]

  React.useEffect(function() {
    // Suscribirse a cambios de features (streaming/refresh)
    var unsubscribe = gb.subscribe(function() {
      setIsOn(gb.isOn(featureKey))
    })
    // Evaluar inmediatamente por si cambió
    setIsOn(gb.isOn(featureKey))
    return function() {
      if (typeof unsubscribe === "function") unsubscribe()
    }
  }, [featureKey])

  return isOn
}

/**
 * Hook custom para obtener el valor de un feature.
 */
export var useFeatureValue = function(featureKey, fallback) {
  var React = require("react")
  var ref = React.useState(gb.getFeatureValue(featureKey, fallback))
  var value = ref[0]
  var setValue = ref[1]

  React.useEffect(function() {
    var unsubscribe = gb.subscribe(function() {
      setValue(gb.getFeatureValue(featureKey, fallback))
    })
    setValue(gb.getFeatureValue(featureKey, fallback))
    return function() {
      if (typeof unsubscribe === "function") unsubscribe()
    }
  }, [featureKey, fallback])

  return value
}



// WEBPACK FOOTER //
// ./src/utils/growthbook.js